import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Route from 'react-router-dom/Route';
import { Helmet } from 'react-helmet';

import {observer} from 'mobx-react'
import store from '../../Store';

import { kindToLocalizedString, eventToPeopleHeaderString, timeframeToLocalizedString } from "../../helpers";

import PersonStripView from '../../../People/elements/PersonStripView'

import EventJumbo from '../../elements/EventJumbo/index'
import ChildEventLink from '../../elements/ChildEventLink'

import Organizations from './Organizations';
import Resources from './Resources';

import styles from './style.sass';

const TimelineItem = ({event, parent, match}, ...props) =>
    <article className={classNames(styles.scheduleItem, event.kind, 'skewed exposed-soft border-bottom')} {...props}>
        <header>
            {
                (event.kind !== undefined || event.timeframe !== undefined) &&
                <span>
                    {
                        event.timeframe !== undefined &&
                        <span dangerouslySetInnerHTML={{__html: timeframeToLocalizedString(event.timeframe, parent.timeframe)}} />
                    }
                    {(event.timeframe !== undefined && event.kind !== undefined) && ' / '}
                    {event.kind !== undefined && kindToLocalizedString(event.kind)}
                </span>
            }
            <h3 className="line-post">
                <ChildEventLink event={event} parent={parent}>{event.title}</ChildEventLink>
            </h3>
        </header>
        {
            event.description !== undefined &&
            <div className="markdown g-type-major" dangerouslySetInnerHTML={{__html: event.description}}/>
        }
        {
            event.people !== undefined &&
            <footer>
                {event.people.map((person, i) => <PersonStripView key={i} person={person}/>)}
            </footer>
        }
    </article>;


const FlatScheduleItem = ({event, parent, match}, ...props) =>
    <li className={styles.scheduleFlatItem}>
        <i />
        {
            event.timeframe !== undefined &&
            <span dangerouslySetInnerHTML={{__html: timeframeToLocalizedString(event.timeframe, parent.timeframe)}} />
        }
        <div>
            <h4>{event.title}</h4>
        {
            event.description !== undefined &&
            <div className="markdown" dangerouslySetInnerHTML={{__html: event.description}}/>
        }
        </div>
    </li>;

const SimplifiedSchedule = ({event, match}, ...props) =>
    <section className={classNames(styles.timeline, {[styles.emptyFirst]: event.schedule[0].description === undefined})}>
        <h3>Program</h3>
        <article className={classNames(styles.scheduleItem, 'skewed exposed-soft border-bottom')}>
            <ul>
            {event.schedule.map((child, i) =>
                <FlatScheduleItem key={i} match={match} parent={event} event={child} />
            )}
            </ul>
        </article>
    </section>;

const FullSchedule = ({event, match}, ...props) =>
    <section className={classNames(styles.timeline, 'grid', {[styles.emptyFirst]: event.schedule[0].description === undefined})}>
        <h3>Program</h3>
        {event.schedule.map((child, i) =>
            <TimelineItem key={i} match={match} parent={event} event={child} />
        )}
    </section>;


@observer
export default class ItemShowPage extends Component {

    static contextTypes = {
        layoutSetHasInvertedTop: PropTypes.func
    };

    async componentWillMount() {
        await store.fetchBySlug(this.props.match.params.slug)
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        this.context.layoutSetHasInvertedTop(600);
    }

    componentWillUnmount() {
        this.context.layoutSetHasInvertedTop(false);
    }

    render() {
        const event = store.bySlug.get(this.props.match.params.slug);

        if (!event) {
            return null
        }

        let showFlatSchedule = true;

        if (event.schedule !== undefined) {
            for (let item of event.schedule) {
                if (item.people !== undefined && item.people.length > 0) {
                    showFlatSchedule = false;
                    break;
                }
            }
        }

        return [

            <Route path={this.props.match.url + '/:slug'} render={
                (props) => null
            }/>,

            <Route exact path={this.props.match.url} render={
                () =>
        <article className={styles.root + ' ' + styles.main + ' ' + event.kind}>

            <Helmet>
                <title>{event.title}</title>
            </Helmet>

            <EventJumbo className={classNames(
                styles.jumbo,
                {[styles.noSchedule]: event.schedule === undefined},
                {[styles.emptyFirst]: event.schedule !== undefined && event.schedule[0].description === undefined},
                'skewed')
            } event={event}/>

            {event.schedule !== undefined && (showFlatSchedule
                ? <SimplifiedSchedule event={event} match={this.props.match} />
                : <FullSchedule event={event} match={this.props.match} />
            )}

            {(event.schedule === undefined || showFlatSchedule) && event.people &&
                <section className={styles.people}>
                    <h3 className="g-type-title-section line-flat">{eventToPeopleHeaderString(event)}</h3>
                    {event.people.map((person, i) => <PersonStripView key={i} person={person}/>)}
                </section>
            }

            {(event.data !== undefined && (event.data.prizes !== undefined || event.data.results !== undefined)) &&
            <section className={classNames(styles.prizesAndResults, {[styles.noResults]: event.data.results === undefined})}>
                {event.data.prizes !== undefined &&
                <div className={classNames(
                    styles.prizes,
                    {'exposed-soft border-bottom skewed-opposite': event.data.results !== undefined}
                )}>
                    <h3 className=
                            {'g-type-title-section ' + (event.data.results !== undefined
                                    ? 'g-type-title-right floating'
                                    : 'line-flat'
                            )}>Nagrody</h3>
                    <div className="markdown g-type-major" dangerouslySetInnerHTML={{__html: event.data.prizes}}/>
                </div>
                }
                {event.data.results !== undefined &&
                <div className={classNames(styles.results)}>
                    <h3 className="g-type-title-section g-type-title-left line-flat">Wyniki</h3>
                    <div className="markdown g-type-major" dangerouslySetInnerHTML={{__html: event.data.results}}/>
                </div>
                }
            </section>
            }

            <Organizations event={event}/>
            <Resources event={event} />
        </article>
    }/>


        ]
    }
}



// WEBPACK FOOTER //
// ./src/modules/Events/pages/Show/index.js